import { Component } from '@angular/core';
import { PaymentService } from '@services/payment.service';

@Component({
  selector: 'app-daily-ledger',
  templateUrl: './daily-ledger.component.html',
  styleUrls: ['./daily-ledger.component.css'],
})
export class DailyLedgerComponent {
  rows: any[] = [];
  loading = false;
  startDate = '';
  endDate = '';
  displayedColumns = ['invoice', 'type', 'name', 'tax', 'new', 'discount', 'paid', 'method'];

  constructor(private paymentService: PaymentService) {
    const now = new Date();
    this.startDate = now.toISOString().slice(0, 10);
    this.endDate = now.toISOString().slice(0, 10);
  }

  load(): void {
    this.loading = true;
    this.paymentService.dailyLedger(new Date(this.startDate), new Date(this.endDate)).subscribe({
      next: (rows) => {
        this.rows = rows || [];
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  money(value: any): string {
    const n = parseFloat(value);
    if (isNaN(n)) {
      return '0.00';
    }
    return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
}
